<template>
    <tbody v-if="!removed">
    <tr :class="[{'more_info': isEditable}, { open: isOpen }]" @click="toggleMoreInfo()">
      <td class="no_padding drag_drop"><span></span></td>
      <td class="no_padding">
        <input type="checkbox"
               :id="'devCheckbox'+device.id"
               :value="device.id"
               @change="onChange"
               :checked="isChecked"
               @click.stop
        />
        <label :for="'devCheckbox'+device.id" @click.stop v-translate>Vybrat</label>
      </td>
      <td data-th="Název zařízení" :class="['first_data', {'clickable': $_loggedUser_action_allowed('devices', 'read')}]">
        <entity-link :id="device.id" type="device">{{ device.name }}</entity-link>
      </td>
        <td data-th="Přednastavený">
            <img v-if="device.pre_provisioned" class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate">
        </td>
        <td data-th="Servisní" v-if="$_loggedUser_action_allowed('serviceDevices', 'create')">
            <img v-if="device.service_device" class="is_set" src="../../../../assets/images/is-set.svg" :alt="'Ano' | translate">
        </td>
        <td data-th="MAC adresa">{{ device.mac_address }}</td>
        <td data-th="Profil">
          <entity-link :id="device.id_profile" type="deviceProfile">{{ device.profile }}</entity-link>
        </td>
      <td data-th="Token" @click.stop="copyToClipboard" style="cursor: auto">
                <span v-if="showDeviceToken" class="dotted token" :title="'Zkopírovat' | translate">
                <span class="help_popup help_popup--no-wrap">{{ device.token }}</span>
            </span>
        {{device.safe_token}}
      </td>
        <td data-th="Typ">
          <entity-link :id="device.id_type" type="deviceType">{{ device.type }}</entity-link>
        </td>
        <td data-th="Model">{{ device.model }}</td>
        <td data-th="Firmware">{{ device.firmware }}</td>
        <td data-th="Application">{{ device.application }}</td>
      <td data-th="Poslední start zařízení" class="right last_data" v-html="$_datetime_format(device.last_start)"></td>
        <td data-th="Vytvořeno" class="right last_data" v-html="$_date_format(device.date_created)"></td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
                    v-if="$_loggedUser_action_allowed('devices', 'read')"
                    class="btn btn_action btn_grey btn_info"
                    @click.stop.prevent="showDeviceDetail(device.id)"
                    :title="$gettext('O zařízení')"
                    target="_blank"
                    v-translate>O zařízení</a>
              <DeviceLogViewerButton
                  v-if="$_loggedUser_action_allowed('deviceLogViewer', 'read')"
                  :url="deviceLogViewerUrl"
                  :mac-address="device.mac_address"
                  :token="device.token"
              />
                <a
                    v-if="isEditable && isDeletable"
                    class="btn btn_action btn_delete"
                    :title="'Smazat' | translate"
                    @click.stop.prevent="emitDeleteDevice"
                >
                    <translate class="translate">Smazat</translate>
				</a>
            </div>
        </td>
    </tr>

    <tr :class="['more_info_content', { open: isOpen }]">
        <td class="no_padding" />
        <td class="no_padding" />
        <td class="first_data">
            <text-input
                    :id="deviceNameInputId"
                    v-model="device.name"
                    :required="true">
                <translate class="translate">Název zařízení</translate>
            </text-input>
        </td>
        <td>
            <p class="field checkbox">
                <input type="checkbox" name="" value=""
                       :id="preprovisionedId"
                       v-model="device.pre_provisioned">
                <label :for="preprovisionedId" v-translate>Přednastavený</label>
            </p>
        </td>
        <td/>
        <td />
        <td>
            <select-box v-if="device.id_profile !== null"
                        :id="deviceProfileSelectId"
                        v-model="device.id_profile"
                        :options="supportedDeviceProfiles"
                        ref="newdeviceprofileref">
                <translate class="translate">Profil zařízení</translate>
            </select-box>
        </td>
        <td/>
        <td/>
        <td/>
        <td/>
        <td/>
        <td v-if="$_readActionAllowedAll"></td>
        <td class="sticky_end"><p>
			<input
					class="btn"
					type="submit"
					:value="'Uložit' | translate"
					@click.stop.prevent="emitUpdateDevice">
		</p></td>
        <td class="first_data"><p></p></td>
    </tr>
    </tbody>
</template>

<script>
    import message from "@/components/mixins/message"
    import DeviceLogViewerButton from "../../devices/detail/DeviceLogViewerButton.vue";
    import links from "../../../mixins/links";
    import EntityLink from "../../../common/EntityLink.vue";

	export default {
		name: "PairedDeviceRow",
    components: { EntityLink, DeviceLogViewerButton},
    mixins: [message, links],
		data: function () {
			return {
				isOpen: false
			}
		},
		props: {
			device: Object,
			deviceProfiles: Array,
      selectedEntities: Array,
      isEditable: Boolean,
      deviceLogViewerUrl: String,
      showDeviceToken: Boolean,
		},
		computed: {
			deviceNameInputId() {
				return 'device-name-' + this.device.id
			},
			deviceProfileSelectId() {
				return 'device-profile-id' + this.device.id
			},
			macAddressInputId() {
				return 'mac-address-' + this.device.id
			},
			removed() {
				return this.device.remove === true
			},
			supportedDeviceProfiles() {
				let supported = []
				this._.forEach(this.deviceProfiles, (profile) => {
					if (this._.includes(profile['supported_device_type_ids'], this.device.id_type)) {
						supported.push(profile)
					}
				})
				return supported
			},
      preprovisionedId() {
				return 'preprovisioned-' + this.device.id
      },
      serviceDeviceId() {
        return 'servicedevice-' + this.device.id
      },
      isChecked() {
        return this.selectedEntities.indexOf(String(this.device.id)) > -1
      },
      isDeletable() {
        return !this.device.service_device || this.$_loggedUser_action_allowed('serviceDevices', 'delete');
      }
		},
		methods: {
			toggleMoreInfo() {
        if(!this.isOpen && this.isEditable)
				this.isOpen = !this.isOpen
			},
      hideMoreInfo() {
				this.isOpen = false
            },
			emitDeleteDevice() {
				this.$emit('delete-device', this.device.id)
			},
			emitUpdateDevice() {
				this.$emit('update-device', {...this.device})
			},
      onChange: function (e) {
        this.$emit('input', e)
      },
			copyToClipboard() {
				this.$copyText(this.device.token)
					.then(() => {
						this.setSuccessMessage(this.$gettext('Token je zkopírován'))
					}, (e) => {
						this.setErrorMessage(this.$gettext('Token se nepodařilo zkopírovat'))
					})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/devices/PairedDeviceRow.vue